(function () {
    'use strict';

    var templateUrl = 'app/shared/admin-base-link/admin-base-link.component.html',
        $ = angular.element;

    angular
        .module('app.shared')
        .component('sc3AdminBaseLink', {
            templateUrl: templateUrl,
            controller: AdminBaseLinkComponent,
            transclude: 'element'
        });

    AdminBaseLinkComponent.$inject = ['$element', '$templateRequest', '$compile', '$scope', 'user', 'adminMode'];
    function AdminBaseLinkComponent($element, $templateRequest, $compile, $scope, user, adminMode) {
        var ctrl = this;
        Object.defineProperty(ctrl, 'isAssociationAdminMode', { get: getIsAssociationAdminMode });
        $templateRequest(templateUrl).then(init);

        function init(template) {
            template = $(template);
            $element.after(template);
            $compile(template)($scope);
        }

        function getIsAssociationAdminMode() {
            return user && user.isAssociationAdmin && user.adminMode == adminMode.Association;
        }
    }
    
})();
